<template>
    <div
        v-if="isNotPayed && !isHideFloatingPoint"
        class="floating-point-container flex-row depth-5"
        :class="[floatingPositionInfo.dock === 'right' ? 'reverse': '', `floating-${floatingPositionInfo.dock}`]"
        :style="floatingPointStyle"
    >
        <div
            class="floating-point flex-row flex-center"
            :class="[collapsed? `collapsed collapsed-${floatingPositionInfo.dock}`: '', { dragging: isDragging }]"
            @click="handleToggleCollapse"
        >
            <img v-if="collapsed" class="floating-point-icon" :src="floatingPointIcon" alt="icon" />
            <i v-else class="fa fa-close"></i>
        </div>
        <transition name="slide-fade">
            <div class="float-content flex-row flex-center" v-show="!collapsed"
                 :class="{'reverse': floatingPositionInfo.dock === 'right'}">
                <div class="float-button flex-col" @click="handleShowUserCenter"
                     v-show="!$route.path.match('/userCenter') && gameActivated">
                    <i class="fa fa-user"></i>
                    {{ $t('用户') }}
                </div>
                <div
                    class="float-button flex-col"
                    @click="showSocialMediaModal = true"
                    v-if="serviceData.social_media && serviceData.social_media.length > 0"
                >
                    <i class="fa fa-share-alt"></i>
                    Media
                </div>
                <div class="float-button flex-col" @click="showConfirmLogout = true" v-show="gameActivated">
                    <i class="fa fa-power-off"></i>
                    {{ $t('注销') }}
                </div>
                <div v-if="false" class="float-button flex-col" @click="handleActiveService">
                    <i class="fa fa-question-circle"></i>
                    Support
                </div>
                <div
                    v-if="false"
                    class="float-button flex-col"
                    @click="handleReload"
                >
                    <i class="fa fa-gear"></i>
                    {{ $t('修复') }}
                </div>
                <!-- 加群: !!serviceData.qq_group_id -->
                <div v-if="false" class="float-button flex-col" @click="handleJoinQQGroup">
                    <i class="fa fa-qq"></i>
                    {{ $t('加群') }}
                </div>
                <div
                    v-if="false"
                    class="float-button flex-col"
                    @click="handleOpenGiftCode"
                    v-show="gift_switch&&gameActivated&&(allCodeList.length>0||myCodeList.length>0)"
                >
                    <i class="fa fa-gift"></i>
                    {{ $t('礼包') }}
                </div>
                <div
                    v-if="false"
                    class="float-button flex-col"
                    @click="handleClickNotice"
                    v-show="notice_switch&&gameActivated&&!(Object.prototype.toString.call(notice) === '[object Array]')"
                >
                    <i class="fa fa-bullhorn"></i>
                    {{ $t('公告') }}
                </div>
                <!-- 公众号: v-if="!!serviceData.gzh_pic || !!serviceData.gzh_name" -->
                <div
                    v-if="false"
                    class="float-button flex-col"
                    @click="openWeixinModal"
                >
                    <i class="fa fa-weixin"></i>
                    {{ $t('公众号') }}
                </div>
                <div
                    v-if="false"
                    class="float-button flex-col"
                    @click="goCouponList"
                    v-show="!$route.path.match('/couponList') && gameActivated"
                >
                    <i class="fa fa-money"></i>
                    {{ $t('优惠券') }}
                </div>
            </div>
        </transition>
        <van-dialog v-model="visibleWeixinGzh" title="公众号" confirm-button-text="关闭">
            <div class="gzh-body">
                <div class="gzh-left">
                    <img class="gzh-img" :src="serviceData.gzh_pic" />
                </div>
                <div class="gzh-right">
                    <div>关注官方公众号</div>
                    <div>领取专属礼包</div>
                    <div>公众号：<span class="gzh-red">{{serviceData.gzh_name}}</span></div>
                    <van-button
                        round
                        size="small"
                        type="primary"
                        @click="onCopy"
                    >
                        点击复制公众号
                    </van-button>
                </div>
            </div>
        </van-dialog>
        <van-dialog
            v-model="serviceActivated"
            title="Support"
        >
            <div class="text-center">
                <div class="m-b text-center">
                    <div class="m-b-sm">
                        If you have any questions, please contact our customer service email, and we will get back to you as soon as possible.
                    </div>
                    <h3>Email: xhskyxgs@gmail.com</h3>
                </div>
            </div>
        </van-dialog>
        <!-- <van-dialog
            v-model="serviceActivated"
            :title="serviceData.title || $t('联系客服')"
            show-cancel-button
            :cancel-button-text="$t('关闭')"
            :confirm-button-text="$t('立即联系')"
            @cancel="closeServiceQQ"
            @close="closeServiceQQ"
            @confirm="addServiceQQ"
        >
            <div class="text-center">
                <div class="m-b text-center">
                    <div class="m-b-sm" v-show="serviceData.describe">{{ serviceData.describe }}</div>
                    <div class="m-b-sm" v-show="serviceData.title">{{ serviceData.title }}</div>
                    <h3 v-show="serviceData.qq">QQ：{{ serviceData.qq }}</h3>
                    <h3 v-show="serviceData.phone">{{ $t('邮箱') }}：{{ serviceData.phone }}</h3>
                    <small>{{ $t('时间') }}：{{ serviceData.service_time || '-' }}</small>
                    <h5>({{ $t('点击“立即联系”无反应，请手动添加QQ') }})</h5>
                </div>
            </div>
        </van-dialog> -->
        <van-dialog
            v-model="showConfirmLogout"
            :title="$t('提示')"
            show-cancel-button
            @confirm="handleLogout"
            @cancel="showConfirmLogout = false"
        >
            <div class="text-center">
                <h3>{{ $t('确认注销并重新登录') }}？</h3>
            </div>
        </van-dialog>
        <transition>
            <save-desktop-tips :show="showSaveAppTip"></save-desktop-tips>
        </transition>
        <van-dialog v-model="showGiftCode" :show-confirm-button = false class="giftCodeUI">
            <div class="van-dialog__header giftCode_header">
                {{ $t('礼包') }}<i class="fa fa-close nav-close-btn" @click="handleCloseGiftCode" ></i>
            </div>
            <div class="tab-slider">
                <div class="tab">
                    <span
                        v-for="(item, index) in items"
                        :key="index"
                        v-bind:class="{ active: actived == index }"
                        @click="handleGiftCodeToggle(index)"
                        >{{ item.tab }}</span
                    >
                </div>
                <div class="tab-content">
                    <div class="">
                        <div class="item" v-for="(item, index) in activedTabContent" :key="index">
                            <div class="item-left">
                                <img :src="item.logo" alt="">
                            </div>
                            <div class="item-middle">
                                <div class="item-middle_name">{{ item.name }}</div>
                                <div v-show="actived==1" class="item-middle-validity">
                                    <div class="item-middle-validity-text">礼包有效期至：{{ item.validity }}</div>
                                </div>
                                <div v-show="actived==1" class="item-middle-code">
                                    <div class="item-middle-code-text">礼包码：{{ item.code }}</div>
                                </div>
                                <div v-show="actived==0" class="item-middle-content"><small>{{ item.content }}</small></div>
                            </div>
                            <div v-show="actived==0"  class="item-right">
                                <button @click="receiveCode(item,$event)">领取</button>
                            </div>
                            <div v-show="actived==1"  class="item-right">
                                <button @click="copyMyCode(item.code,$event)">复制</button>
                            </div>
                        </div>
                    </div>
                    <div v-show="activedTabContent.length == 0" style="text-align:center;padding:10px 0;color:#808080;">
                        暂无记录
                    </div>
                </div>
            </div>
        </van-dialog>
        <van-dialog v-model="showCopyCodeUI" title="礼包领取成功" confirm-button-text="我知道了" theme="round-button" confirm-button-color="var(--theme-color)" class="copyGiftCodeUI">
            <div class="m-b text-center content">
                <div class="m-b-sm content-middle">
                    <div class="content-middle-left"><small>{{ copyCode }}</small></div>
                    <div class="content-middle-middle"><small>|</small></div>
                    <div class="content-middle-right">
                        <button @click="copyMyCode(copyCode,$event)">复制</button>
                    </div>
                </div>
            </div>
        </van-dialog>
        <van-dialog v-model="showNowticeUI" :show-confirm-button = false class="noticeUI">
            <div class="van-dialog__header noticeUI-header">
                {{notice.title || '游戏公告'}}
            </div>
            <div class="text-center">
                <div v-if="!!notice.img" class="noticeUI-imgBox">
                    <img :src="notice.img" alt="">
                </div>
                <div class="m-b text-center m-b-sm noticeUI-content">
                    {{notice.content}}
                </div>
                <div v-if="!!serviceData.qq_group_id" class="m-b text-center noticeUI-buttonBox">
                    <div style="width:50%;">
                        <button class="noticeUI-button1" @click="handleJoinQQGroup">一键加群</button>
                    </div>
                    <div style="width:50%;">
                        <button class="noticeUI-button1" @click="readNewNotice(notice,$event)">已阅</button>
                    </div>
                </div>
                <div v-if="!!!serviceData.qq_group_id" class="m-b text-center">
                    <button class="noticeUI-button1 noticeUI-button2" @click="readNewNotice(notice,$event)">已阅</button>
                </div>
            </div>
        </van-dialog>
        <h5-dialog
            closeable
            mode="full"
            @on-close="showCouponModal = false"
            v-show="!!coupon_logo && showCouponModal && gameActivated"
            style="z-index:1007;"
        >
            <img
                class="center-img"
                :src="coupon_logo"
                @click="onCouponJump"
            />
        </h5-dialog>
        <van-dialog
            v-model="showSocialMediaModal"
            title="Social Media"
            :confirm-button-text="$t('关闭')"
            @cancel="closeSocialMediaModal"
            @close="closeSocialMediaModal"
            @confirm="closeSocialMediaModal"
        >
            <div class="social-media-list">
                <div
                    v-for="(item, index) in serviceData.social_media"
                    :key="index"
                    class="social-media-item"
                    @click="handleOpenSocialLink(item.url)"
                >
                    <span class="social-media-name">{{ item.name }}</span>
                    <span class="social-media-btn">{{ $t('加入') }}</span>
                </div>
            </div>
        </van-dialog>
    </div>
</template>

<script>
import { Dialog, Dialog as VanDialog, Button } from 'vant'
import SaveDesktopTips from '@/components/SaveDesktopTips'
import browser from '@/utils/browser'
import {
    receiveCode
} from '@/service'
import { getNoticeReadedList, setNoticeReadedList, getLocalAccountData } from '@/utils/storage'
import { mapState } from 'vuex'
import H5Dialog from './H5Dialog.vue'
import floatingPointIcon from '@/assets/images/floating-point-icon.png'

const SCREEN_WIDTH = window.screen.availWidth
const SCREEN_HEIGHT = window.screen.availHeight
export default {
    name: 'FloatingPoint',
    components: {
        H5Dialog,
        SaveDesktopTips,
        VanDialog: VanDialog.Component,
        VanButton: Button,
    },
    data() {
        return {
            floatingPositionInfo: {
                x: 0,
                y: SCREEN_HEIGHT / 2,
                dock: 'left',
            },
            collapsed: true,
            collapseTimer: null,
            serviceActivated: false,
            showConfirmLogout: false,
            showGiftCode: false,
            actived: 0,
            activedTabContent:[],
            items: [
                {
                    tab: "游戏礼包",
                    actived: 0,
                },
                {
                    tab: "我的礼包",
                    actived: 1,
                },
            ],
            copyCode:0,
            showCopyCodeUI:false,
            showNowticeUI: false,
            visibleWeixinGzh: false,
            showCouponModal: false,
            showSocialMediaModal: false,
            floatingPointIcon,
            isDragging: false,
        }
    },
    computed: {
        isNotPayed() {
            return !(this.$route.path.match('/chargeCenter'))
        },
        isHideFloatingPoint() {
            // 2026.6.6 链接参数is_native为1，走安卓原生登录
            return this.$route?.query?.is_native == '1' && browser.isAndroid
            // return window?.JsJingYouNativeBridge?.nativeJingYouLogin instanceof Function
        },
        floatingPointDom() {
            return this.$el.querySelector('.floating-point')
        },
        floatingPointRect() {
            if (this.floatingPointDom) {
                return this.floatingPointDom.getBoundingClientRect()
            } else {
                return {
                    width: 50,
                    height: 50,
                }
            }
        },
        floatingPointStyle() {
            return {
                [this.floatingPositionInfo.dock]: `${this.floatingPositionInfo.x}px`,
                top: `${this.floatingPositionInfo.y}px`,
            }
        },
        serviceData() {
            const info = this.$store.state.serviceInfo
            console.log('>>> this.$store.state.serviceInfo', info)
            return {
                ...info,
                // social_media 来自 /game/h5-init 接口，存在 app 模块中
                social_media: this.$store.state.app.social_media || [],
            }
        },
        showSaveAppTip() {
            if (this.$store.state.app.gameConfig.bookmark_auto_login) {
                if (browser.isWebApp) {
                    return false
                }
                if (this.$store.state.gameFrameInfo.frame) {
                    return false
                }
                if (browser.isiOS) {
                    return !this.collapsed
                }
                return false
            }
            return false
        },
        gameActivated() {
            return this.$store.state.gameFrameInfo.frame
        },
        gift_switch(){
            return this.$store.state.app.gift_switch
        },
        allCodeList() {
            return this.$store.state.allCodeList
        },
        myCodeList() {
            return this.$store.state.myCodeList
        },
        notice_switch(){
            return this.$store.state.app.notice_switch
        },
        ...mapState({
            notice: state => state.notice,
            showServiceQQ: state => state.app.showServiceQQ,
            showSocialMediaModalStore: state => state.app.showSocialMediaModal,
            coupon_logo: state => state?.app?.coupon_logo, // 优惠券弹窗图片
            isFirstOpenByLogin: state => state.isFirstOpenByLogin,
        }),

    },
    watch: {
        gameActivated(bool) {
            console.log('>>>> this.isFirstOpenByLogin', this.isFirstOpenByLogin)
            if (bool && this.isFirstOpenByLogin) {
                this.showCouponModal = true
                this.$store.dispatch("updateIsFirstOpenByLogin", false)
            }
        },
        notice(newValue , oldValue) {
            if(this.gameActivated){
                if(newValue.elastic == 2){
                    let list = getNoticeReadedList();
                    const {
                        accountData = getLocalAccountData(),
                    } = this.$store.state
                    if(list[accountData.username] != newValue.elastic){
                        this.showNowticeUI = true;
                        list[accountData.username] = newValue.elastic;
                        setNoticeReadedList(list);
                    }
                }else if(newValue.elastic == 3){
                    this.showNowticeUI = true;
                }
            }
        },
        showServiceQQ(newVal) {
            if (newVal === true) {
                this.serviceActivated = true
            }
        },
        showSocialMediaModalStore(newVal) {
            if (newVal === true) {
                this.showSocialMediaModal = true
            }
        },
    },
    methods: {
        onCouponJump() {
            this.showCouponModal = false
            this.goCouponList()
        },
        // 复制公众号
        onCopy() {
            this.$copyText(this.serviceData.gzh_name).then(()=> {
                this.$toast('复制成功')
            }, ()=> {
                this.$toast('复制失败')
            })
        },
        // 打开公众号弹窗
        openWeixinModal() {
            this.visibleWeixinGzh = true
        },
        // 关闭客服qq弹窗
        closeServiceQQ() {
            this.$store.dispatch('app/updateShowServiceQQ', false)
        },
        // 关闭社交媒体弹窗
        closeSocialMediaModal() {
            this.$store.dispatch('app/updateShowSocialMediaModal', false)
        },
        // 加客服qq
        addServiceQQ() {
            const groupLink = this.serviceData.qq_url
            this.$dialog({ title: '正在尝试跳转QQ' })
            // 2022.05.27 iOS新壳包跳转方式（game_id: 1112004）
            if (window?.webkit?.messageHandlers?.ios_jumpstore?.postMessage) {
                window.webkit.messageHandlers.ios_jumpstore.postMessage(groupLink)
            } else {
                const tempFrame = document.createElement('iframe')
                tempFrame.setAttribute('frameborder', '0')
                tempFrame.setAttribute('src', groupLink)
                tempFrame.setAttribute('style', 'visibility: hidden;z-index: 0')
                tempFrame.onload = () => {
                    setTimeout(() => {
                        document.body.removeChild(tempFrame)
                        Dialog.close()
                    }, 2000)
                }
                tempFrame.onerror = () => {}
                document.body.appendChild(tempFrame)
            }
        },
        // 加QQ群
        handleJoinQQGroup() {
            const groupLink = this.serviceData.qq_group_id
            this.$dialog({
                title: '正在尝试跳转QQ群',
            })

            // 2022.05.27 iOS新壳包跳转方式（game_id: 1112004）
            if (window?.webkit?.messageHandlers?.ios_jumpstore?.postMessage) {
                window.webkit.messageHandlers.ios_jumpstore.postMessage(groupLink)
            } else {
                const tempFrame = document.createElement('iframe')
                tempFrame.setAttribute('frameborder', '0')
                tempFrame.setAttribute('src', groupLink)
                tempFrame.setAttribute('style', 'visibility: hidden;z-index: 0')
                tempFrame.onload = () => {
                    console.log('JoinQQGroup Frame loaded')
                    setTimeout(() => {
                        document.body.removeChild(tempFrame)
                        Dialog.close()
                    }, 2000)
                }

                tempFrame.onerror = () => {
                    //    打开链接失败
                    // this.$dialog({
                    //     title: '打开QQ异常',
                    // })
                }
                document.body.appendChild(tempFrame)
            }
        },
        handleToggleCollapse() {
            this.collapsed = !this.collapsed
            this.collapseTimer !== null && clearTimeout(this.collapseTimer)
            if (this.collapsed === false) {
                this.$store.dispatch('getGameService')
                this.collapseTimer = setTimeout(() => {
                    this.collapsed = true
                    clearTimeout(this.collapsed)
                    this.collapseTimer = null
                }, 3500)
            }
        },
        handleTouchMove(e) {
            this.isDragging = true
            if(!this.showNowticeUI){
                e.preventDefault()
                const touch = e.touches[0]
                if (touch.pageX > SCREEN_WIDTH / 2) {
                    this.floatingPositionInfo.dock = 'right'
                    this.floatingPositionInfo.x = SCREEN_WIDTH - touch.pageX
                } else {
                    this.floatingPositionInfo.dock = 'left'
                    this.floatingPositionInfo.x = touch.pageX
                }
                this.floatingPositionInfo.y = touch.pageY - this.floatingPointRect.height / 2
            }
        },
        handleTouchStart(e) {
            this.isDragging = false
        },
        handleTouchEnd(e) {
            this.isDragging = false
            this.$el.classList.add('animated')
            setTimeout(() => {
                if (this.floatingPositionInfo.x > SCREEN_WIDTH / 2) {
                    this.floatingPositionInfo.x = SCREEN_WIDTH - this.floatingPointRect.width
                    // this.floatingPositionInfo.dock = 'right'
                } else {
                    this.floatingPositionInfo.x = 0
                    // this.floatingPositionInfo.dock = 'left'
                }
                setTimeout(() => {
                    this.$el.classList.remove('animated')
                }, 300)
            }, 100)
        },
        handleActiveService() {
            this.serviceActivated = true
        },
        handleReload() {
            typeof window.forceReload === 'function' && window.forceReload()
        },
        handleShowUserCenter() {
            this.$router.push({
                path: 'userCenter',
                query: {
                    ...this.$route.query,
                    ...this.$store.state.app.originQuery,
                },
            })
        },
        goCouponList() {
            this.$router.push({
                path: 'couponList',
                query: {
                    ...this.$route.query,
                    ...this.$store.state.app.originQuery,
                },
            })
        },
        handleLogout() {
            window.postMessage({ key: 'reLogin', value: true }, '*')

            // 2025.11.12 回传安卓壳包 注销事件
            try {
                window?.JsJingYouNativeBridge?.nativeLoginOfGoogleLogout?.()
                console.log('JsJingYouNativeBridge.nativeLoginOfGoogleLogout<Android> | nativeLoginOfGoogleLogout >>> ')
            } catch (err) {
                console.error('>>> post Android nativeLoginOfGoogleLogout fail', err)
            }

            // 2022.04.11 回传注销事件给安卓端
            try {
                window?.JHJsImpl?.onLogout()
                console.log('JHJsImpl.onLogout<Android> | >>> ')
            } catch (err) {
                console.log('回传安卓端失败：', err)
            }
        },
        async handleOpenGiftCode() {
            await this.$store.dispatch("getMyCode")
            this.handleGiftCodeToggle(0);
        },
        async handleGiftCodeToggle(index) {
            await this.$store.dispatch(index==0 ? "getCodeList" : "getMyCode")
            if(this.allCodeList.length>0||this.myCodeList.length>0){
                this.actived = index;
                this.activedTabContent = index==0 ? this.allCodeList : this.myCodeList;
                this.showGiftCode = true
            }else{
                this.showGiftCode = false
            }
        },
        handleCloseGiftCode() {
            this.showGiftCode = false
        },
        receiveCode(item,$event){
            // console.log(item)
            // console.log($event)
            receiveCode({ 
                game_id: this.$store.state.app.appConfig.game_id, 
                gift_id:item.id 
            }).then(res => {
                console.log('receiveCode res ', res)
                if (Number(res.code) === 0) {
                    this.copyCode = item.code;
                    this.showCopyCodeUI = true;
                    let index = this.allCodeList.findIndex(data => data.id === item.id);
                    if (index > -1) {
                        this.allCodeList.splice(index,index+1);
                    }
                    this.$store.dispatch("getCodeList")
                }
            })
        },
        copyMyCode(code,$event){
            this.$copyText(code).then((e)=> {
                this.$toast('复制成功')
            }, (e)=> {
                this.$toast('复制失败')
            })
        },
        async handleClickNotice() {
            await this.$store.dispatch("getNewNotice")
            if(!(Object.prototype.toString.call(this.notice) === '[object Array]')){
                this.showNowticeUI = true
            }
        },
        readNewNotice(data,$event){
            this.showNowticeUI = false;
        },
        handleOpenSocialLink(url) {
            if (!url) {
                this.$toast(this.$t('链接无效'))
                return
            }

            try {
                // 2026.10.23 回传安卓壳包 - 打开外链
                if (window?.JsJingYouNativeBridge?.openUrl) {
                    window?.JsJingYouNativeBridge?.openUrl?.(url)
                    console.log('JsJingYouNativeBridge.openUrl<Android> | openUrl >>> ', url)
                    return
                }
            } catch (err) {
                console.error('>>> post Android openUrl fail', err)
            }

            // 使用 a 标签方式打开外部链接，兼容移动端浏览器和 WebView
            const a = document.createElement('a')
            a.href = url
            a.target = '_blank'
            a.rel = 'noopener noreferrer'
            document.body.appendChild(a)
            a.click()
            setTimeout(() => {
                if (a.parentNode) {
                    document.body.removeChild(a)
                }
            }, 100)
        }

    },
    mounted() {
        this.$el.addEventListener('touchstart', this.handleTouchStart)
        this.$el.addEventListener('touchmove', this.handleTouchMove)
        this.$el.addEventListener('touchend', this.handleTouchEnd)
    },
}
</script>

<style scoped lang="scss">
.floating-point-container {
    position: fixed;
    left: initial;
    right: initial;

    &.animated {
        transition: left .25s, right .25s;
    }

    &.reverse {
        .slide-fade-enter, .slide-fade-leave-to {
            transform: translateX(25px);
            opacity: 0;
        }
    }
}


.floating-point {
    height: 46px;
    width: 46px;

    .floating-point-icon {
        width: 46px;
        height: 46px;
        object-fit: contain;
    }
    /*display: block;*/
    background-color: $themeColor;
    color: $white;
    transition: width .25s, height .25s, opacity .25s, transform .25s, margin .25s;
    border-radius: 50%;
    text-align: center;
    box-sizing: border-box;
    transform: rotate(0);
    opacity: .9;

    &.collapsed {
        height: 42px;
        width: 42px;
        opacity: .5;
        // transform: rotate(45deg);
    }

    &.collapsed-left {
        margin-left: -27px;
        margin-right: 0;
    }

    &.collapsed-right {
        margin-right: -26px;
        margin-left: 0;
    }

    &.dragging {
        opacity: 1;
    }
}


.float-content {
    margin: 0 4px;
}

.float-button {
    height: 42px;
    width: 42px;
    font-size: 12px;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    border: 2px solid $themeColor;
    box-sizing: border-box;
    background-color: $white;
    color: $themeColor;
    margin: 0 4px;
}

.slide-fade-enter-active {
    transition: all .25s linear;
}

.slide-fade-leave-active {
    transition: all .25s linear;
}

.slide-fade-enter, .slide-fade-leave-to {
    transform: translateX(-25px);
    opacity: 0;
}


:root {
    --animate-duration: 1s;
    --animate-delay: 1s;
    --animate-repeat: 1
}

.animate__animated {
    -webkit-animation-duration: 1s;
    animation-duration: 1s;
    -webkit-animation-duration: var(--animate-duration);
    animation-duration: var(--animate-duration);
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both
}

@media (prefers-reduced-motion: reduce), print {
    .animate__animated {
        -webkit-animation-duration: 1ms !important;
        animation-duration: 1ms !important;
        -webkit-transition-duration: 1ms !important;
        transition-duration: 1ms !important;
        -webkit-animation-iteration-count: 1 !important;
        animation-iteration-count: 1 !important
    }

    .animate__animated[class*=Out] {
        opacity: 0
    }
}

@-webkit-keyframes fadeInDownBig {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -2000px, 0);
        transform: translate3d(0, -2000px, 0)
    }

    to {
        opacity: 1;
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
    }
}

@keyframes fadeInDownBig {
    0% {
        opacity: 0;
        -webkit-transform: translate3d(0, -2000px, 0);
        transform: translate3d(0, -2000px, 0)
    }

    to {
        opacity: 1;
        -webkit-transform: translateZ(0);
        transform: translateZ(0)
    }
}

.animate__fadeInDownBig {
    -webkit-animation-name: fadeInDownBig;
    animation-name: fadeInDownBig
}

.giftCodeUI .giftCode_header {
    position: relative;
    padding: 15px 0;
}
.giftCodeUI .giftCode_header .nav-close-btn {
  position: absolute;
  right: 10px;
  top: 0;
  bottom: 0;
  width: 32px;
  height: 32px;
  line-height: 32px;
  margin: auto;
}
.giftCodeUI .tab-slider .tab {
  display: flex;
  height: 40px;
  line-height: 40px;
//   background: #ccc;
}
.giftCodeUI .tab-slider .tab span {
  display: block;
  width: 100%;
  text-align: center;
  cursor: default;
}
.giftCodeUI .tab-slider .tab .active {
//   background: $red;
  color: $red;
  border-bottom: 2px solid $red;
}
.giftCodeUI .tab-slider .tab-content {
  height: 60vh;
  overflow: auto;
  padding: 10px;
}
.giftCodeUI .tab-slider .tab-content .item {
  height: 100px;
  width: 100%;
  text-align: center;
  display: flex;
  padding: 5px 0;
}
.giftCodeUI .tab-slider .tab-content .item .item-left {
  width: 30%;
  text-align:center;
  display: flex;
  justify-content: center;
  align-items: center;
//   background-color: rebeccapurple;
}
.giftCodeUI .tab-slider .tab-content .item .item-left img{
  height:90px;
  width:90px;
}
.giftCodeUI .tab-slider .tab-content .item .item-middle {
  width: 50%;
//   background-color: wheat;
  position: relative;    
  padding: 0 10px;
  box-sizing: border-box;
  text-align: left;
}
.giftCodeUI .tab-slider .tab-content .item .item-middle .item-middle_name {
  margin-top: 5px;
  font-weight:600;
}
.giftCodeUI .tab-slider .tab-content .item .item-middle .item-middle-validity {
  position: absolute;
  width: 100%;
  bottom: 37px;
  height: 28px;
  line-height: 20px;
  box-sizing: border-box;
  overflow: hidden;
  color:#808080;
  font-size:12px;
}
.giftCodeUI .tab-slider .tab-content .item .item-middle .item-middle-validity .item-middle-validity-text {
  transform: scale(0.7);
  -webkit-transform: scale(0.7);
  width: 142.8571%;
  position: relative;
  left: -21%;
}
.giftCodeUI .tab-slider .tab-content .item .item-middle .item-middle-code {
  position: absolute;
  bottom: 15px;
  height: 30px;
  line-height: 30px;
  color:#808080;
  font-size:12px;
}
.giftCodeUI .tab-slider .tab-content .item .item-middle .item-middle-code .item-middle-code-text {
  transform: scale(0.8);
  -webkit-transform: scale(0.8);
  width: 125%;
  position: relative;
  left: -12%;
}
.giftCodeUI .tab-slider .tab-content .item .item-middle .item-middle-content {
  position: absolute;
  width: 90%;
  bottom: 5px;
  height: 32px;
  line-height: 16px;
  box-sizing: border-box;
  overflow: hidden;
  color:#808080;
  font-size:12px;
}
.giftCodeUI .tab-slider .tab-content .item .item-right {
  width: 20%;
  display: flex;
  justify-content: center;
  align-items: center;
//   background-color: yellowgreen;
}
.giftCodeUI .tab-slider .tab-content .item .item-right button {
  border-radius:50px;
  background:transparent;
  color:var(--theme-color);
  border:2px solid var(--theme-color);width:60px;
}
.copyGiftCodeUI .content {
  margin-top: 8px;
  display:flex;
  justify-content: center;
  align-items: center;
}
.copyGiftCodeUI .content .content-left {
  width:5%;
}
.copyGiftCodeUI .content .content-middle {
  width:90%;
  background-color:#eeeeee;
  display:flex;
}
.copyGiftCodeUI .content .content-middle .content-middle-left {
  width:65%;
  line-height: 35px;
}
.copyGiftCodeUI .content .content-middle .content-middle-middle {
  width:5%;
  line-height: 35px;
}
.copyGiftCodeUI .content .content-middle .content-middle-right {
  width:30%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.copyGiftCodeUI .content .content-middle .content-middle-right button {
  border-radius:50px;
  background-color:var(--theme-color);
  color:$white;
  width:60px;
  border:0;
}

.noticeUI .noticeUI-header {
  padding: 15px 0;
}
.noticeUI .noticeUI-imgBox {
  width:90%;
  display:inline-block;
}
.noticeUI .noticeUI-imgBox img{
  width:100%;
  max-height:10vh;
}
.noticeUI .noticeUI-content{
  display:inline-block;
  border-radius:7px;
  width:90%;
  border:2px solid var(--theme-color);
  padding:5px;
  box-sizing:border-box;
  min-height:10vh;
  max-height:20vh;
  overflow:auto;
  text-align:left;
}
.noticeUI .noticeUI-buttonBox{
  display:flex;
}
.noticeUI .noticeUI-button1{
  border-radius:7px;
  background-color:var(--theme-color);
  color:$white;
  width:64%;
  border:0;
  height: 35px;
}
.noticeUI .noticeUI-button2{
  width:32%;
}
.gzh-body {
    display: flex;
    flex-direction: row;
}
.gzh-left {
    padding: 12px 24px;
}
.gzh-right {
    flex: 1;
    text-align: center;
    padding-top: 12px;
}
.gzh-img {
    width: 100px;
    height: 100px;
}
.gzh-red {
    font-weight: bold;
    color: red;
}
.center-img {
    width: 100%;
}
.social-media-list {
    max-height: 50vh;
    overflow-y: auto;
    padding: 10px 20px;
}
.social-media-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 0;
    border-bottom: 1px solid #eee;
    &:active {
        opacity: 0.7;
    }
    &:last-child {
        border-bottom: none;
    }
}
.social-media-name {
    font-size: 14px;
    color: #333;
}
.social-media-btn {
    font-size: 12px;
    color: #fff;
    background-color: #1989fa;
    padding: 4px 12px;
    border-radius: 4px;
}
</style>
